import { render, staticRenderFns } from "./AbkGraduatesCompetencesBox.vue?vue&type=template&id=7331ac3a&scoped=true&"
import script from "./AbkGraduatesCompetencesBox.vue?vue&type=script&lang=js&"
export * from "./AbkGraduatesCompetencesBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkGraduatesCompetencesBox.vue?vue&type=style&index=0&id=7331ac3a&scoped=true&lang=scss&"
import style1 from "./AbkGraduatesCompetencesBox.vue?vue&type=style&index=1&id=7331ac3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7331ac3a",
  null
  
)

export default component.exports